import axios from "axios";
import { CompanyDtlApiRes, DivisionDtlApiRes } from "../types";
import { GET_USER_COMPANY_URL, GET_USER_DIVISION_URL } from "../constants";
import { fetchCompanySuccess } from "./reducers/company";
import { fetchDivisionSuccess } from "./reducers/division";
import { Dispatch } from "redux";

export function fetchCompanies() {
  return (dispatch: Dispatch) => {
    axios.get<CompanyDtlApiRes>(GET_USER_COMPANY_URL).then((res) => {
      dispatch(fetchCompanySuccess(res.data.result));
    });
  };
}

export function fetchDivisions(payload: any) {
  return (dispatch: Dispatch) => {
    axios
      .post<DivisionDtlApiRes>(GET_USER_DIVISION_URL, payload)
      .then((res) => {
        dispatch(fetchDivisionSuccess(res.data.result));
      });
  };
}
